export default defineNuxtRouteMiddleware(async (to, from) => {
  const authStore = useAuthStore();

  if (!authStore.isSmsVerified) {
    if (to.name === "verifisering") {
      return abortNavigation(
        "Loop prevented - this middleware should not be used on the verification page"
      );
    }

    return await navigateTo({
      path: "/verifisering",
      // query: {
      //   redirect: to.fullPath,
      // },
    });
  }
});
